<template>
  <section-header size="xl" variants="dividing">
    <template v-slot:content>
      <div class="w-full lg:w-auto">
        <div class="flex items-center mb-25">
          <product-label-group
            :product="product"
            :base-properties="baseProperties"
            :is-b2b-pdp="isB2bPdp"
            class="mr-1"
          />
          <span
            v-if="product.marketingModelYear && !product.isArchived"
            qaid="product-modelyear"
            class="text-md"
            v-html="product.marketingModelYear"
          />
          <span
            v-if="product.modelYearIntroAndCurrent && product.isArchived"
            qaid="product-modelyear-archive"
            class="text-md"
            v-html="product.modelYearIntroAndCurrent"
          />
        </div>
        <h1 qaid="product-name" class="heading heading--xl" v-html="product.name" />
      </div>
    </template>
    <template v-slot:actions>
      <div v-if="!product.isArchived" class="buttons">
        <a
          :href="getUrl(`/hang-tags/${product.code}`)"
          qaid="create-hangtag-btn"
          class="button button--primary button--hollow button--skinny"
        >
          {{ bp('createHangTag') }}
        </a>
        <a
          :href="getUrl(`/sell-sheet/${product.code}`)"
          qaid="create-sellsheet-btn"
          class="button button--primary button--hollow button--skinny"
        >
          {{ bp('createSellSheet') }}
        </a>
      </div>
    </template>
  </section-header>
</template>
<script>
import {Url} from '@/utils/url';
import ProductLabelGroup from '@/components/ProductLabelGroup';
import SectionHeader from '@/components/SectionHeader';

export default {
  name: 'PdpProductHeader',
  components: {ProductLabelGroup, SectionHeader},
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isB2bPdp: true,
    };
  },
  methods: {
    getUrl: (url) => Url.withContextPath(url),
  },
};
</script>
